import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { Editor } from 'primereact/editor';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { useEffect, useState } from 'react';

import { GetEditorFormats } from '../../shared';
import GenderDropdown from '../gender-dropdown';

function ChildUpdate({ open, data, onClose }) {
    const [index, setIndex] = useState(0);
    const [active, setActive] = useState(true);
    const [nameFirst, setNameFirst] = useState('');
    const [nameLast, setNameLast] = useState('');
    const [gender, setGender] = useState('');
    const [dob, setDob] = useState('');
    const [notes, setNotes] = useState('');

    const buttonDisabled = () => {
        if (!nameFirst) {
            return true;
        }

        return false;
    };

    const onCancel = () => {
        onClose(null);
    };

    const onUpdate = () => {
        const updateData = {
            child: {
                active,
                nameFirst,
                nameLast,
                gender,
                dob: dob?.toISOString ? dob.toISOString() : '',
                notes
            },
            index
        };

        onClose(updateData);
    };

    const FooterContent = (
        <div>
            <Button
                label="Cancel"
                icon="pi pi-times"
                onClick={onCancel}
                className="p-button-text"
            />
            <Button
                label="Update"
                disabled={buttonDisabled()}
                icon="pi pi-check"
                onClick={onUpdate}
            />
        </div>
    );

    // Set Data
    useEffect(() => {
        setIndex(data.index);
        setActive(data.child.active);
        setNameFirst(data.child.nameFirst);
        setNameLast(data.child.nameLast);
        setGender(data.child.gender?._id ? data.child.gender._id : data.child.gender);
        setDob(data.child.dob ? new Date(data.child.dob) : '');
        setNotes(data.child.notes);
    }, [data]);

    return (
        <Dialog
            header="Update Child"
            visible={open}
            onHide={onCancel}
            footer={FooterContent}
            className="w-9"
        >
            <div className="mt-2">
                <div className="card flex flex-wrap gap-3 p-fluid">
                    <div className="flex-auto">
                        <label htmlFor="activeId" className="font-bold block mb-2">
                            Active
                        </label>

                        <InputSwitch
                            inputId="activeId"
                            checked={active}
                            onChange={(e) => {
                                setActive(e.target.value);
                            }}
                        />
                    </div>

                    <div className="flex-auto">
                        <label htmlFor="genderId" className="font-bold block mb-2">
                            Gender
                        </label>

                        <GenderDropdown
                            genderId={gender}
                            onChange={(genderId) => {
                                setGender(genderId);
                            }}
                        />
                    </div>

                    <div className="flex-auto">
                        <label htmlFor="dobId" className="font-bold block mb-2">
                            Date of Birth
                        </label>

                        <Calendar
                            inputId="dobId"
                            value={dob}
                            onChange={(e) => setDob(e.value)}
                            showIcon
                            showButtonBar
                        />
                    </div>
                </div>

                <div className="card flex flex-wrap gap-3 p-fluid">
                    <div className="flex-auto">
                        <label htmlFor="nameFirstId" className="font-bold block mb-2">
                            First Name
                        </label>

                        <InputText
                            id="nameFirstId"
                            value={nameFirst}
                            keyfilter={/^[a-zA-Z ]*$/}
                            maxLength={24}
                            onChange={(e) => {
                                setNameFirst(e.target.value);
                            }}
                        />
                    </div>

                    <div className="flex-auto">
                        <label htmlFor="nameLastId" className="font-bold block mb-2">
                            Last Name
                        </label>

                        <InputText
                            id="nameLastId"
                            value={nameLast}
                            keyfilter={/^[a-zA-Z ]*$/}
                            maxLength={24}
                            onChange={(e) => {
                                setNameLast(e.target.value);
                            }}
                        />
                    </div>
                </div>

                <div className="card flex flex-wrap gap-3 p-fluid">
                    <div className="flex-auto">
                        <label htmlFor="notesId" className="font-bold block mb-2">
                            Notes
                        </label>

                        <Editor
                            id="notesId"
                            value={notes}
                            headerTemplate={<GetEditorFormats />}
                            onTextChange={(e) => setNotes(e.htmlValue)}
                            style={{ height: '320px' }}
                        />
                    </div>
                </div>
            </div>
        </Dialog>
    );
}

export default ChildUpdate;
